<div
  (scrolled)="onScroll()"
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="10"
  [scrollWindow]="false"
  class="table-wrapper overflow-auto xs:h-[calc(100vh-45rem)] sm:h-[calc(100vh-45rem)] md:h-[calc(100vh-30rem)]"
  infiniteScroll
>
  <table
    [class.hidden]="loading && isFirstPage"
    [dataSource]="dataSource"
    mat-table
  >
    <ng-container matColumnDef="name"
                  sticky
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Name
      </th>
      <td *matCellDef="let eachRow"
          class="w-[20rem] min-w-[20rem] md:w-[30rem] md:min-w-[30rem]"
          mat-cell>
          <span
            (click)="eachRow.status.key > userStatusMap.inProcess ?
             openUserDetails(eachRow) : {}"
            [class.clickable]="eachRow.status.key > userStatusMap.inProcess"
          >
            {{ eachRow.firstName }} {{ eachRow.lastName }}
          </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="currentWeight"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Current Weight (lbs)
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.currentWeight }}
      </td>
    </ng-container>
    <ng-container matColumnDef="weightChange"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Weight Change since baseline
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.weightChange }}
      </td>
    </ng-container>
    <ng-container matColumnDef="weightLossAlert"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        <div class="flex items-center gap-[0.5rem]">
          Safety Alert
          <span
            [matTooltip]="'2 recent measures show weight loss greater than 2 lbs/week.  Please check.'"
            matTooltipClass="custom-tooltip"
            matTooltipPosition="below"
            style="display: inline-flex; align-items: center; cursor: pointer;"
          >
            <app-icon
              class="tooltip-icon"
              svgIcon="info"
              style="color: #59B3A9; width: 1.6rem; height: 1.6rem;"
            ></app-icon>
          </span>
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[10rem] min-w-[10rem]"
          mat-cell>
        <app-icon
          *ngIf="eachRow.weightLossAlert"
          class="weight-loss-icon"
          svgIcon="alert"
        ></app-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="currentBMI"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Current BMI (kg/m<sup>2</sup>)
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.currentBMI }}
      </td>
    </ng-container>
    <ng-container matColumnDef="changeBMI"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Change in BMI (kg/m<sup>2</sup>)
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.changeBMI }}
      </td>
    </ng-container>
    <ng-container matColumnDef="currentMedianBMI"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Current Percent Over Median BMI
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.currentMedianBMI }}
      </td>
    </ng-container>
    <ng-container matColumnDef="changeMedianBMI"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Change in Percent Over Median BMI
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.changeMedianBMI }}
      </td>
    </ng-container>
    <ng-container matColumnDef="changeOverPercentile"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Change in Percent Over 95%ile BMI
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem]"
          mat-cell>
        {{ eachRow.changeOverPercentile }}
      </td>
    </ng-container>
    <ng-container matColumnDef="currentOverPercentile"
    >
      <th
        *matHeaderCellDef
        mat-header-cell
      >
        Current Percent Over 95%ile BMI
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15em] min-w-[15rem]"
          mat-cell>
        {{ eachRow.currentOverPercentile }}
      </td>
    </ng-container>
    <tr *matHeaderRowDef="displayedColumns; sticky: true"
        mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;"
        mat-row></tr>

  </table>
  <div *ngIf="loading"
       [ngClass]="{ 'initial': isFirstPage }"
       class="table-loader w-full flex justify-center items-center">
    <mat-spinner/>
  </div>
  <div
    *ngIf="!loading && !dataSource.data?.length"
    class="no-data flex flex-col justify-center items-center"
  >
    <div class="text">
      No data matching the filter.
    </div>
  </div>
</div>
